export class Setting {
  workhoursexceed: number = 0;
  callingdaysnumber: number = 0;
  motorDifferenceHours: number = 0;
  id: string = null;

  getWorkhoursexceed() {
    return this.workhoursexceed;
  }

  getCallingdaysnumber() {
    return this.callingdaysnumber;
  }

  getMotorDifferenceHours() {
    return this.motorDifferenceHours;
  }

  getId() {
    return this.id;
  }

  setWorkhoursexceed(workhoursexceed: number) {
    this.workhoursexceed = workhoursexceed;
  }

  setCallingdaysnumber(callingdaysnumber: number) {
    this.callingdaysnumber = callingdaysnumber;
  }

  setMotorDifferenceHours(diffHour: number) {
    this.motorDifferenceHours = diffHour;
  }
  setId(id: string) {
    this.id = id;
  }
}
